module.exports = __webpack_public_path__ + "static/009-9a0bd58e65082fc4ba1eb799af02e4e2.jpeg";